module.exports = {
  'school.task_result.something_bad_happened': () => 'Файл не загружен. Попробуйте ещё раз',
  fileTooBig: () => 'Sorry, mate, tis’ file is too big',
  'school.task_result.wrong_upload': (params = {}) => `Формат ${(params.format || '').toUpperCase()}
  не принимается. Пожалуйста, загрузите простой файл с изображением,
  например гиф, джипег, ПНГ или ПДФ`,
};
